import { useQuery } from '@tanstack/react-query'
import { useAuth, useOrganization } from '@clerk/clerk-react'

import { evalKeys } from '@/lib/queryKeys'
import { fetchEvalCase } from '../api'

export function useEvalCaseQuery(caseId?: string) {
  const { getToken } = useAuth()
  const { organization } = useOrganization()

  return useQuery({
    queryKey: evalKeys.caseDetail(organization?.id, caseId),
    queryFn: async () => {
      if (!caseId) throw new Error('caseId is required')
      const token = await getToken()
      if (!token) throw new Error('No authentication token available')
      return fetchEvalCase(token, caseId)
    },
    enabled: Boolean(caseId),
    staleTime: 30_000,
    refetchOnWindowFocus: false,
  })
}
